import { useAtomValue } from 'jotai';

import { ItemWrapper } from './index.styles';

import Heading from '../../../../../../heading';
import PageWrapper from '../../../../../../page_wrapper';
import Items from '../../main/rewards/items';

import { vendorCardRewardsState } from '../../../../../../../store';

export default function RewardsMain() {
  const cardRewards = useAtomValue(vendorCardRewardsState);
  const availableCardRewards = cardRewards.filter((reward) => reward.can_be_used);

  return (
    <PageWrapper>
      <Heading align="center">Rewards</Heading>
      <ItemWrapper>
        <Items items={availableCardRewards} />
      </ItemWrapper>
    </PageWrapper>
  );
}
